import { Button, Chip, Stack, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { ListItemBox } from "lib/@components/ListItemBox"
import { DATE_FORMATS } from "lib/@constants/date-format"

export function AuthoringDraftRestorePointRow({ item }) {
    const { onRestoreDraftHistoryPoint, draftHistoryBusy } = useBoundContext()

    return (
        <ListItemBox sx={{ alignItems: "flex-start", gap: 1.5, py: 1.25 }}>
            <Stack spacing={0.35} flex={1} minWidth={0}>
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Typography variant="subtitle2">{item?.summary || "Saved restore point"}</Typography>
                    <If truthy={item?.isCurrent}>
                        <Chip size="small" label="Current" color="primary" variant="outlined" />
                    </If>
                </Stack>
                <Typography variant="caption" color="text.secondary">
                    {formatChangedAt(item)}
                </Typography>
            </Stack>
            <Button
                size="small"
                color="primary"
                disabled={Boolean(item?.isCurrent) || Boolean(draftHistoryBusy)}
                onClick={handleRestore}
            >
                Restore
            </Button>
        </ListItemBox>
    )

    function handleRestore() {
        onRestoreDraftHistoryPoint?.(item)
    }

    function formatChangedAt(restorePoint) {
        const changedAt = restorePoint?._modified ?? restorePoint?._created
        if (!changedAt) return "Unknown time"
        return new Date(changedAt).format(DATE_FORMATS.long)
    }
}
